// Shop explorer (apps/site/components/product-explorer.tsx) and product variant pricing.

// Explorer: category, search and pack-size filters over server-rendered cards.
document.querySelectorAll('[data-shop-explorer]').forEach((explorer) => {
  const cards = [...explorer.querySelectorAll('[data-shop-card]')];
  const familyButtons = [...explorer.querySelectorAll('[data-shop-family]')];
  const packButtons = [...explorer.querySelectorAll('[data-shop-pack]')];
  const search = explorer.querySelector('[data-shop-search]');
  const count = explorer.querySelector('[data-shop-count]');
  const grid = explorer.querySelector('[data-shop-grid]');
  const empty = explorer.querySelector('[data-shop-empty]');
  const packsOf = (card) => card.dataset.packs.split(',').filter(Boolean).map(Number);

  // ?search= and ?pack= preselect filters, as on try.swabtek.com/tests.
  const params = new URLSearchParams(window.location.search);
  const requestedPack = Number(params.get('pack'));
  const state = {
    family: '',
    query: (params.get('search') || '').slice(0, 100),
    pack: packButtons.some((b) => Number(b.dataset.shopPack) === requestedPack) ? requestedPack : 0,
  };

  // Hide pack sizes no listed product comes in.
  packButtons.forEach((button) => {
    const size = Number(button.dataset.shopPack);
    if (size && !cards.some((card) => packsOf(card).includes(size))) button.hidden = true;
  });

  const matches = (card) => {
    const query = state.query.toLowerCase().trim();
    const inFamily = !state.family || card.dataset.family === state.family;
    return (
      inFamily &&
      (state.pack === 0 || packsOf(card).includes(state.pack)) &&
      card.dataset.search.includes(query)
    );
  };

  const press = (buttons, active) => {
    buttons.forEach((button) => {
      const on = button === active;
      button.classList.toggle('selected', on);
      button.setAttribute('aria-pressed', String(on));
    });
  };

  const render = () => {
    let shown = 0;
    cards.forEach((card) => {
      const visible = matches(card);
      card.hidden = !visible;
      if (visible) shown += 1;
    });
    press(familyButtons, familyButtons.find((b) => b.dataset.shopFamily === state.family));
    press(packButtons, packButtons.find((b) => Number(b.dataset.shopPack) === state.pack));
    if (search.value !== state.query) search.value = state.query;
    let label = `${shown} ${shown === 1 ? 'test' : 'tests'}`;
    if (state.family) label += ` · ${state.family}`;
    if (state.pack) label += ` · ${state.pack}-test packs`;
    count.textContent = label;
    grid.hidden = shown === 0;
    empty.hidden = shown !== 0;
  };

  familyButtons.forEach((button) =>
    button.addEventListener('click', () => {
      state.family = button.dataset.shopFamily;
      render();
    }),
  );
  packButtons.forEach((button) =>
    button.addEventListener('click', () => {
      state.pack = Number(button.dataset.shopPack);
      render();
    }),
  );
  search.addEventListener('input', () => {
    state.query = search.value;
    render();
  });
  explorer.querySelector('[data-shop-reset]').addEventListener('click', () => {
    Object.assign(state, { family: '', query: '', pack: 0 });
    render();
  });

  render();
});

// Product page: the variant select updates the price, the add button and the URL.
document.querySelectorAll('[data-shop-product]').forEach((product) => {
  const select = product.querySelector('select[name="id"]');
  const data = product.querySelector('[data-shop-variants]');
  if (!select || !data) return;
  const variants = JSON.parse(data.textContent);
  const price = product.querySelector('[data-shop-price]');
  const add = product.querySelector('[data-shop-add]');

  select.addEventListener('change', () => {
    const variant = variants.find((item) => String(item.id) === select.value);
    if (!variant) return;
    price.innerHTML = variant.price_html;
    add.disabled = !variant.available;
    add.innerHTML = variant.available ? add.dataset.addLabel : add.dataset.soldOutLabel;
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  });
});
